module.exports = __webpack_public_path__ + "h5/img/huangguan_footer.b0df85c6.png";